import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import {
  trigger,
  style,
  animate,
  transition,
  query,
  stagger,
  keyframes,
  state,
  group,
} from "@angular/animations";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import {StoreService} from '../store.service';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: "app-case-practice-performance-report",
  animations: [
    trigger("bestPathBoxAnimation", [
      state("hideBestPathBox", style({ opacity: 0, transform: "scale(0, 0)" })),
      state("showBestPathBox", style({ opacity: 1, transform: "scale(1, 1)" })),
      transition(
        "hideBestPathBox => showBestPathBox",
        animate(
          "200ms",
          keyframes([
            style({ transform: "scale(0.1, 0.1)", opacity: 0.1 }),
            style({ transform: "scale(0.2, 0.2)", opacity: 0.2 }),
            style({ transform: "scale(0.3, 0.3)", opacity: 0.3 }),
            style({ transform: "scale(0.4, 0.4)", opacity: 0.4 }),
            style({ transform: "scale(0.5, 0.5)", opacity: 0.5 }),
            style({ transform: "scale(0.6, 0.6)", opacity: 0.6 }),
            style({ transform: "scale(0.7, 0.7)", opacity: 0.7 }),
            style({ transform: "scale(0.8, 0.8)", opacity: 0.8 }),
            style({ transform: "scale(0.9, 0.9)", opacity: 0.9 }),
            style({ transform: "scale(1, 1)", opacity: 1 }),
          ])
        )
      ),
      transition(
        "showBestPathBox => hideBestPathBox",
        animate(
          "200ms",
          keyframes([style({ opacity: 1 }), style({ opacity: 0 })])
        )
      ),
    ]),
    trigger("analysisBoxAnimation", [
      state(
        "hideAnalysisBox",
        style({ opacity: 0, transform: "translate(-100%)" })
      ),
      state("showAnalysisBox", style({ opacity: 1 })),
      transition(
        "hideAnalysisBox => showAnalysisBox",
        animate(
          "200ms",
          keyframes([
            style({
              transform:
                "matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "45%",
            }),
            style({
              transform:
                "matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "47%",
            }),
            style({
              transform:
                "matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "49%",
            }),
            style({
              transform:
                "matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "50%",
            }),
          ])
        )
      ),
      transition(
        "showAnalysisBox => hideAnalysisBox",
        animate(
          "500ms",
          keyframes([style({ opacity: 1 }), style({ opacity: 0 })])
        )
      ),
    ]),
    trigger("starAnimation", [
      state("hideStar", style({ opacity: 0 })),
      state("showStar", style({ opacity: 1 })),
      transition("hideStar => showStar", [
        style({ opacity: 1 }),
        query(".starReport", style({ opacity: 0 })),
        query(".starReport5", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport4", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport3", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport2", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport1", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
      ]),
    ]),
  ],
  templateUrl: "./case-practice-performance-report.component.html",
  styleUrls: [
    "./case-practice-performance-report.component.css",
  ],
})
export class CasePracticePerformanceReportComponent
  implements OnInit, AfterViewInit {
  currentName: any;
  currentTotal: any;
  currentDescription: any;
  currentAnalysis: any;

  practiceId: any;
  exerciseId: any;
  learningPathId: any;

  report: any;

  //报告等级KA对象：传递给等级组件
  reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

  // chuanjie: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;
  finished: boolean;
  practiceMetaId: number;
  analysisBoxShow: boolean;
  bestPathBoxShow: boolean;
  starShow: boolean;
  reportName: string;

  tutor: any;
  optimum: any;

  mode: number;
  lvCls: string;

  // 皮肤样式
  skinColor: string = "LightBlue";

  starPicUrl: string;

  pathClickable: boolean;
  goToListClickedStatus: boolean;
  redoClickedStatus: boolean;
  type : string
  itemClickEnable: boolean = false;
  //配置信息
  abilityConfig: AbilityConfig;
  assetsRoute: string = "../../assets";
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private storeService:StoreService
  ) {}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    let that = this;
    this.isShowReportLv = false;
    this.bestPathBoxShow = false;
    this.analysisBoxShow = false;
    this.starShow = false;
    this.pathClickable = true;
    this.goToListClickedStatus = false;
    this.redoClickedStatus = false;

    this.route.queryParams.subscribe(queryParams=>{
      this.type=queryParams['type']
    })
    this.route.params.subscribe((params) => {
      this.practiceId = params["practiceId"];
      this.exerciseId = params["exerciseId"];
      this.learningPathId = params["learningPathId"];
      this.updateExerciseReports();

      this.apiService
        .ajax({
          type: "get",
          url: "/sr/learningtour",
        })
        .subscribe((result) => {
          this.learningTour = result;
        });

      this.optimum =
        '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p>' +
        '<p class="performanceTitle fontBlod">第一阶段：计划</p>' +
        '<p>零经验的新人林薇写了7个KRA，<b class="fontBlue">【最佳选择】</b>如下：</p>' +
        '<div class="bg-lightBlue"><p class="smLineHeight">- 创新方案</p><p class="smLineHeight"> - 活动项目管理</p><p class="smLineHeight"> - 客户满意</p><p class="smLineHeight"> - 支持销售</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>KRA在制定的过程中需要注意不要错把活动当结果，活动策划、客户拜访都是活动，而发展客户是销售的KRA，林薇作为活动部的成员，这个也不是她的KRA。</p></div>' +
        '<p class="fontBlod">帮助林薇选完KRA后，再来看目标定得是否SMART：</p>' +
        '<div class="imageBlock"><img src="' + this.assetsRoute + '/picture/casepracticeperformance/SMART.png" /></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>界定KRA表现有四个方面：质量、数量、及时效率、成本。你可以运用目标公式“动词+指标+数值+时间”，这样就可以轻松制定出符合SMART原则的绩效目标啦！</p></div>' +
        '<p class="fontBlod">确定了关键结果领域和目标，林薇开始了第二步：能力设定。</p>' +
        "<p>林薇为了达成绩效目标所需要的就这五项能力：</p>" +
        '<div class="imageBlock"><img src="' + this.assetsRoute + '/picture/casepracticeperformance/Ability.png" /></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>能力指的是达成目标或吻合公司价值观所需要的知识、技能及需要展现的行为。你在帮助林薇设定能力的时候需要注意要与她的关键结果领域(KRA)相关，另外，特别说明，能力（决策）设定的时候需要考虑到企业的价值观（自驱力）。</p></div>' +
        '<p class="fontBlod">确定了目标和能力，计划阶段已经完成了一半。接下来，该考虑考虑林薇的个人能力发展了。</p>' +
        '<div class="imageBlock"><img src="' + this.assetsRoute + '/picture/casepracticeperformance/develop.png" /></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>在选择发展机会时候不仅要注意“强弱搭配，效果翻倍”，同时需要考虑该机会是否与绩效目标相关。发展方案要按照“学习-应用-反馈”三部曲来制定，并且尽量具体，这样才是落地的、可执行的发展方案。</p></div>' +
        '<p class="fontBlod">绩效计划的三份设定都做完了。该与林薇进行绩效面谈了。</p>' +
        '<p><span class="fontLW">林薇</span><span>老板，你修改的那个目标，客户对所执行活动在“创意”一项上的平均评分达到9分，这个目标我觉得高到不合理啊！</span></p>' +
        '<p><span class="fontBlue">我</span><span>这个目标确实是有挑战的。可以先说说你觉得难在哪里吗？</span></p>' +
        '<p><span class="fontLW">林薇</span><span>我看过前两年的记录，即便是公司里的那些大神，这项上的平均分也不过8.5分而已。老板，我还是个新手……</span></p>' +
        '<p><span class="fontBlue">我</span><span>确实，这个目标高于以往，你又是新人，肯定会信心不足。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>老板你懂我！那您看是不是这个目标酌情下调一点？</span></p>' +
        '<p><span class="fontBlue">我</span><span>林薇，我理解你的担忧，但我不建议调整目标。前两年公司刚起步，客户需求不复杂，对创意要求不高。但现在公司面临的竞争愈发激烈，只有与众不同的方案才能让我们获得差异化的优势。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>您话都说到这份上了，我也只能硬着头皮上了。</span></p>' +
        '<p><span class="fontBlue">我</span><span>我一直觉得创新是你的优势，你唯一需要补强的，是如何精准匹配客户需求的能力。对此你有什么想法吗？</span></p>' +
        '<p><span class="fontLW">林薇</span><span>谢谢老板肯定！您说的这个，或许我可以去参加一些培训？</span></p>' +
        '<p><span class="fontBlue">我</span><span>除了培训外，你还可以从哪里获得这些经验？</span></p>' +
        '<p><span class="fontLW">林薇</span><span>我可以去问问公司里那些对客户了解的人，比如销售！</span></p>' +
        '<p><span class="fontBlue">我</span><span>很好的想法，我再给你一些建议……</span></p>' +
        '<div class="bg-lightBlue">解决了目标上的分歧，你和林薇在计划阶段成功地达成了一致。</div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>当员工自己制定的绩效目标与主管设定的不一致时，主管可以运用提问、分享理由、同理心来引导下属共同参与，达成一致。</p></div>' +
        '<p class="performanceTitle fontBlod">第二阶段：执行</p>' +
        '<p class="fontBlod">“STAR观察日记”</p>' +
        "<p>STAR 1.</p>" +
        '<p class="smLineHeight">事件：本月15号，林薇负责的XX公司实体店开业庆典的活动非常的成功，晚上你组织大家开了庆功宴，中途，你在去卫生间的路上听到小A、小B和小C的谈话。</p>' +
        '<p class="smLineHeight">小A说：“不晓得林薇怎么搞的，今天的活动的时候，都没人去播放开业视频和现场的音乐，还好Amy反应快，没出什么乱子。“</p>' +
        '<p class="smLineHeight">小B说：“欸呀，反正活动都顺利结束了，你管那么多干嘛。“</p>' +
        '<p class="smLineHeight">小C说：“不管怎么说，以后大家都机灵一点就好。”</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight"><b>Step1.</b>虽然大家今天都很嗨，但是你还是准备找林薇说一下。</p><p class="smLineHeight"><b>Step2.</b>薇薇，今天的活动非常成功，祝贺你啊！不过呢，你没有把现场人员的工作安排清楚，导致活动的时候都没人播放开业视频和现场音乐，建议你下次把现场人员的名单和对应的职责打印出来，发给每个人，让大家清楚知道自己该做什么，保证活动顺利进行，万无一失。</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>Step 1.考查反馈三原则中的及时，当事件发生的时候，尽可能及时给予下属反馈，有效地帮助她改进，避免在后续的工作中再犯；Step 2.考查反馈三原则中的具体，给下属反馈的时候，正面反馈需要遵循STAR原则，待改善的反馈不要遗忘STAR后面还有一个AR哦。</p></div>' +
        "<p>STAR 2.</p>" +
        '<p class="smLineHeight">事件：上个月初林薇接了一个14岁成人礼活动的案子，在前期跟客户沟通清楚后，出了一份策划方案给客户。但是，客户自己也想不清楚到底要什么，林薇不厌其烦地与客户沟通深度挖掘客户的需求，明确他要的理想效果。活动非常成功，结束后，客户专程送来鲜花表示感谢。</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">看到林薇桌上的鲜花，你找林薇说：“薇薇，看到你桌上的鲜花就知道你这次的活动让客户非常满意！一开始客户其实也没想清楚要什么，你通过反复沟通，帮助他明确他要的理想效果，非常的客户导向，继续加油哦！“</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>不是只有待改善的事件的需要反馈，正面的事件也需要反馈，这里考查反馈三原则中的平衡。正面的反馈可以帮助下属认识到自己做的好的行为，在后续的工作中保持这样的行为。</p></div>' +
        "<p>STAR 3.</p>" +
        '<p class="smLineHeight">事件：本周一上午，林薇与销售部门的魏宇本来约好11：00要去拜访客户。由于林薇提前没有准备好物料，出发前也没有检查，快到客户楼下的时候才发现，急急火火地给Cathy打电话， Cathy放下手里的工作，火急火燎地送过去才解决了问题。下午林薇回到办公室，你决定找她谈谈。</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">薇薇，上午你跟魏宇一起去拜访客户没带全物料，这件事你有什么想法嘛？</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>绩效是下属自己的绩效，那么在追踪绩效的过程中让下属进行反馈就非常有必要了。让下属反馈可以让下属更容易接受自己存在的问题，有效帮助后续改进。</p></div>' +
        "<p>STAR 4.</p>" +
        '<p class="smLineHeight">事件：林薇本月配合销售部门做产品展示会，现场活动非常成功。次活动产生的意向客户比以往增加大概10%。活动结束后，大家议论纷纷。</p>' +
        '<p class="smLineHeight">柯胜：“邀请了插画师参加展示会，现场将客户的想法和需求用插画的形式展现出来，林薇的这个想法真的太赞了！效果完全超乎想象！“</p>' +
        '<p class="smLineHeight">季宁：“是呢，策划部林薇真的是创意无极限呢，不过结束后，她说家里有事，一溜烟就走了，丢我们在收拾摊子。“</p>' +
        '<p class="smLineHeight">魏宇：“是的呢，我反正每次跟她合作都是一结束她就溜了，从来没善过后。”</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">找林薇谈了谈，“薇薇，这次的产品展示会，你邀请了插画师参加展会，直观给客户呈现方案，带来全新的体验，这次活动意向客户比往次增加10%，这个做法非常有创意！”</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>给下属反馈的时候注意，与绩效目标无关的事件可以不反馈，相反，与绩效目标相关的事件，无论是正面的还是待改善的均需要反馈。</p></div>' +
        "<p>STAR 5.</p>" +
        '<p class="smLineHeight">事件：上周五公司组织了去滴水湖骑行的集体团建活动，全公司的人都参加了，只有林薇因为最近工作比较累，婉拒了这次团建。你的上级领导对这件事情好像蛮不高兴的。</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">算了，跟绩效目标又没关系，就不说了吧。</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>反馈需要注意不是所有的事件都需要反馈，你只需要对与达成年底绩效目标相关的事件进行反馈即可，将你宝贵的时间花在更重要的事情上吧。</p></div>' +
        '<p class="performanceTitle fontBlod">第三阶段：回顾</p>' +
        '<p class="fontBlod">目标评分</p>' +
        '<p class="smLineHeight">目标：截止第四季度末，执行活动总金额达到200万。</p>' +
        '<p class="smLineHeight">结果：本年度我负责了23场活动，平均每场活动金额为12.9万，执行活动总金额296.7万。</p>' +
        '<p class="smLineHeight">下属自评：3</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">4 – 超过期待</p></div>' +
        '<p class="smLineHeight">目标：满意度达到8.5分</p>' +
        '<p class="smLineHeight">结果：本年度的23场活动，平均客户满意分数为8.9.分。</p>' +
        '<p class="smLineHeight">下属自评：3</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">3- 符合期待</p></div>' +
        '<p class="smLineHeight">目标：截止第四季度末，所执行活动平均毛利率达到40%以上。</p>' +
        '<p class="smLineHeight">结果：本年度23场的活动，其中14场毛利率都达到40%，9场活动由于实际成本超过预算，毛利率未达标。年度平均毛利率为35%。</p>' +
        '<p class="smLineHeight">下属自评：3</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">2- 低于期待</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>绩效目标的评分相对容易，根据设定的目标最终实际的结果进行对比评分即可。</p></div>' +
        '<p class="fontBlod">能力打分</p>' +
        "<p>事例一：</p>" +
        '<p class="smLineHeight">投诉事件：胡辰小朋友生日会  2月12日</p>' +
        '<p class="smLineHeight">你们这个公司太不专业了！上周六是我儿子的生日会。之前明明就千叮咛万嘱咐，生日会上游戏奖品公仔一定要换成我儿子和他的小朋友们最喜欢的小、猪、佩、奇！结果呢，还是送过来一堆标配的玩具。说什么“客户至上”，简直把客户的话都当成耳旁风！</p>' +
        '<p class="smLineHeight">内部情况核实：</p>' +
        '<p class="smLineHeight">经核查，活动负责人林薇确实有将“客户的游戏奖品要小猪佩奇”的要求写进需求备注，但未与具体活动人员做沟通和确认。她表示自己在之后的活动中会加强跟进和沟通。</p>' +
        '<p class="smLineHeight">后续处理记录：</p>' +
        '<p class="smLineHeight">由活动部主管及负责人出面，向客户当面致歉，并给出当次费用减免及三次活动折扣优惠的补偿。客户接受致歉，对公司的诚意表示认可。</p>' +
        "<p>事例二：</p>" +
        '<p class="smLineHeight">来自你的观察 3月2日</p>' +
        '<p class="smLineHeight">“小猪佩奇”的事故发生后，你跟进了她的下一场活动。你观察到在现场准备时，她主动把将活动流程上客户的额外需求，逐条与跟所有执行人员确认。整场活动非常顺利，无任何客户不满的情况发生。在活动的第二天，林薇进行了客户回访，并撰写出详尽的客户回访报告，发邮件给相关的同事。据你了解，之后的所有活动，林薇每次均给出了回访报告。</p>' +
        "<p>事例三：</p>" +
        '<p class="smLineHeight">来自客户HR部门的感谢信：7月20日</p>' +
        '<p class="smLineHeight">非常感谢你们的员工林薇。这次我们公司“仲夏之夜”活动放在了XX岛上，结果第二天大风大雨，突然降温了20多度。我们都很担心所有人会冻到。没想到，林薇前一天晚上特地加班加点，为每个人调配来了御寒衣物，还迅速调整了活动方案，把户外活动都改到室内。 虽然这次的活动因为天气原因，没有达到预期效果，但还是很感谢你们林薇“想客户所想”的贴心服务和快速的应变方案。</p>' +
        "<p>事例四：</p>" +
        '<p class="smLineHeight">茶水间与销售的谈话：9月11日</p>' +
        '<p class="smLineHeight">“你们新来的林薇，年纪轻轻，倒是挺能扛事。上个月有个14岁成人礼活动，方案是她负责的。哦哟喂，那客户真是个百年难遇的奇葩，今天要这样，明天又不满意要去掉，反反复复。连我到后来都忍不住要掀桌子了。但是林薇很沉得住气，一遍遍往深里挖客户的需求，出了17份方案！现场准备时，又很认真地一条条核对客户的额外需求有没有完成。最后出来的活动效果很棒，我看客户现场都感动哭了。”</p>' +
        '<div class="bg-lightBlue"><p class="fontBlue">「最佳选择」</p><p class="smLineHeight"></p><p class="smLineHeight">4分- 超过期待。</p></div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>在给下属进行能力评分的时候需要注意，负面的行动如果发生较早，在后期有改进，则不影响评分。同时，若在其他事件中，下属展现出超过期待的行为，并且总体趋势也是超过期待，那么建议给4分-超过期待。</p></div>' +
        '<p class="fontBlod">给林薇绩效目标和能力评分后，你约了林薇进行绩效谈话</p>' +
        '<p><span class="fontLW">林薇</span><span>（敲门，紧张地笑了笑）老板，早。</span></p>' +
        '<p><span class="fontBlue">我</span><span>林薇，早啊，请进。……怎么，看你好像有点紧张？</span></p>' +
        '<p><span class="fontLW">林薇</span><span>是、是的，觉得是期末了，自己来领成绩单的。</span></p>' +
        '<p><span class="fontBlue">我</span><span>别紧张，绩效不是考试，绝对不是要把你们辛苦打拼一整年的成果分成三六九等。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>好、好的。那我想听听老板对我工作的评价。</span></p>' +
        '<p><span class="fontBlue">我</span><span>那从目标开始吧。</span></p>' +
        '<div class="bg-lightBlue">目标回顾开始得很顺利，但是到了“执行活动平均毛利率”的目标，分歧产生了……</div>' +
        '<p><span class="fontBlue">我</span><span>项目成本管理部分，唔，就是平均毛利率，我看你打了3分，我想了解一下。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>哦，原来定的目标是40%，但是真的做起来很难。方案要惊艳出彩，活动要客户满意，就会投进去额外的人力和物料成本，把毛利率给拉低了。</span></p>' +
        '<p><span class="fontBlue">我</span><span>既要打造让客户满意的体验，又要控制成本，确实很不容易。但是在这个目标上，我没办法给你“符合期望”的分数。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>什、什么？我也是为了让客户更满意啊。难道这些不重要吗？</span></p>' +
        '<p><span class="fontBlue">我</span><span>你的客户导向，我都看在眼里，稍后谈能力的时候再好好聊聊。不过，设这个指标是为了确保公司能从活动业务里赚到合理的回报——毕竟，大家的工资福利什么的也不是大风刮来的。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>明白了。</span></p>' +
        '<p><span class="fontBlue">我</span><span>也许，我们能想一想，有什么办法能帮你更好地控制项目成本？</span></p>' +
        '<p><span class="fontLW">林薇</span><span>我其实自己有想过，想再听听老板的意见……【林薇兴致勃勃地提出了她的想法，想在来年的成本管理中加以尝试。】</span></p>' +
        '<div class="bg-lightBlue">目标谈完了，接下来……</div>' +
        '<p><span class="fontBlue">我</span><span>你的客户导向能力很出色，你的好几项目标都因为你的客户导向完成得很好。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>啊，没想到老板给我打了4分，开心！</span></p>' +
        '<p><span class="fontBlue">我</span><span>特别是客户回访报告的做法，这能帮助我们积累客户反馈数据，很有价值。</span></p>' +
        '<p><span class="fontLW">林薇</span><span>嗯，我也是觉得不管以后是要做用户分析，或是成功故事宣传，也许都用得上。</span></p>' +
        '<p><span class="fontBlue">我</span><span>没错，我希望这个做法能推广开来，你有什么好的建议？</span></p>' +
        '<p><span class="fontLW">林薇</span><span>当然可以！回访报告做得多了，我已经总结出一些经验了。我可以找时间跟大家分享一下，有必要的话，还可以提供访谈模板给大家。（松了口气）来之前，是惴惴不安领试卷的感觉，结果居然有一种拿到奖状的感觉，神奇~~</span></p>' +
        '<div class="bg-lightBlue">谈话结束</div>' +
        '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p><p>绩效谈话的目不仅是就绩效评分结果达成共识，更重要的是回顾过去及展望未来。在这个过程中，当主管与下属对绩效目标的评分结果不一致时，主管要能展现出共同参与的行动，帮助下属分析未达标的原因，了解达标的经验；在下属表现好的地方（无论是超额完成目标还是能力超过期待），主管要不吝啬肯定，为员工创造扩大优势的机会。</p></div>';

      // '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p><p class="dialogBox">做完练习之后，你应该感受到变革的艰辛了。你的关键行为有没有满星呢？一起来看看一个优秀主管应该怎么做吧！</p><p class="changeTitle fontBlod">变革start，告诉团队小伙伴！</p><p>作为技术部的主管也是项目负责人，你收到变革消息后，准备在本周二上午10：00给项目组成员开个会。这时，拿出了笔记本，把开会要说明的重点写在了笔记本上。</p><div class="bg-lightOrange"><p class="fontOrange">「最佳选择」</p><p class="smLineHeight">1.受外来竞争影响，A、B、C大客户不断流失，一季度营业额下降10%。</p><p class="smLineHeight">2.拓宽产品类型，各部门抽调成员，成立新的项目组开发新产品。</p><p class="smLineHeight">3.被抽调员工的工作内容和优先级将发生变化。</p><p class="smLineHeight">4.若能率先开发上线，便可抢占先机，赢得市场。</p></div><p>会议开始了，你按照会前准备的重点，跟团队成员进行了阐述。大家反应各不相同。' +
      // '下属在会议中清楚的知道了什么在变，为什么要变以及对组织的预期收益。在会议结束前，你给团队成员布置了任务。（任务：做调研报告  时间：下周三15：00前）</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>这个场景中需要运用变革加速器一，说明了变革的内容、愿意及预期收益。主管会议上说的清楚，下属在会活就不会麻烦不断。</p></div><p>如果你在会议上表达清楚，就不会有下面的下属找你麻烦的事情了。</p><p><span class="fontLW">林短信</span><span>老大，为什么要搞这个新项目啊？现在的项目不是盈利很好吗？我们对那个领域又不熟，去了不也是送人头吗？</span></p><p><span class="fontBlue">我</span><span>你也看过我们的业绩报表，对比去年同期，我们营业额下降10%。</span></p><p><span class="fontBlue">我</span><span>正因为大家对这个领域都不熟，我们才有机会抢占先机，对你个人来说也是一个不错的提升机会。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>可以看出，林薇对于前面的会议上说的变革缘由并不是很清楚。通过告诉林薇营业额的下降和对公司和个人的收益，能够让林薇理解到底为什么要变。</p></div><p><span class="fontWY">魏宇</span><span>老板，听说我们要做编程游戏了，太好了！我之前有关注过这方面的信息，我觉得我们一定能成功！</span></p><p><span class="fontBlue">我</span><span>很高兴听到你这么说，说说看你对这个项目的理解。</span></p><p><span class="fontWY">魏宇</span><span>不就是要开战了嘛？不过我不确定对我来说到底会有怎么样的变化？</span></p><p><span class="fontBlue">我</span><span>这是个全新领域，我们都要学习新的内容。具体做什么我们在项目启动会上会有个初步讨论。目前你需要尽快把手里的工作交接出去，熟悉新项目，把重心放在新产品上。</span></p><p><span class="fontWY">魏宇</span><span>好的，老板。我知道了，我接下来就准备起来了。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>通过对话可以看出，魏宇对变革是持适应变革的态度的，这个时候，如果不能讲清楚变革的内容，可能就会把下属从适应的阶段推向观望的边缘。</p></div><p><span class="fontKS">柯胜</span><span>老大，我不想做这个新项目！我现在手里的XX产品快要上线，已经忙成狗了！</span></p><p><span class="fontBlue">我</span><span>看起来你是不理解这个决定。我理解这时抽调你过来会打乱你原本的计划，我们需要讨论下解决方案。</span></p><p><span class="fontKS">柯胜</span><span>做这个新产品对我们到底有什么好处啊？</span></p><p><span class="fontBlue">我</span><span>我们的新产品将会是市面上首款此类型的游戏，不仅能帮公司稳固在行业内的地位，提升营业额，而且，我想届时你在游戏产品界的地位，就更是当之无愧的一哥了。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>很显然柯胜对变革是抗拒的心态，会议中如果没有把变革的对公司、组织或个人的收益，就会出现柯胜这样怒气腾腾的状态。</p></div>' +
      // '<p class="changeTitle fontBlod">有人抗拒，快去灭火</p><p>已经是周四的上午10:00，你仍然没有收到柯胜的报告。你决定找他聊一聊。</p><p><span class="fontKS">柯胜</span><span>老板，你找我啊。</span></p><p><span class="fontBlue">我</span><span>柯胜，上次会议说到新项目的调研报告，我还没收到你的。我想了解一下，是有什么问题吗？</span></p><p><span class="fontKS">柯胜</span><span>老大，你知道的啊。XXX产品的新版本才刚刚上市，要做的事情很多。我每天晚上整理数据和用户评论都要弄到很晚……</span></p><p>【导师反馈】懂他才能搞定他，了解下属感受是化解抗拒情绪的关键一步。</p><p><span class="fontBlue">我</span><span>我看到你对A产品新版本的热情，现在这个阶段你一定放不开手。</span></p><p><span class="fontKS">柯胜</span><span>是啊，自己一手做出来的产品，交给别人总是不放心啊。</span></p><p>【导师反馈】你很好地同理了下属的情绪，接下来要怎么见招拆招？</p><p><span class="fontBlue">我</span><span>编程游戏的项目势在必行，这个在团队中我也已经沟通多次。可以说说现在让你把重心放到新项目，你自己有什么担心或困难吗？</span></p><p><span class="fontKS">柯胜</span><span>对新项目我的确是有点担心。我跟做这行的朋友聊过，他说这个领域局势很不明朗，大家都还在烧钱，盈利模式也不清楚。现在就要去趟这浑水，我心里有点慌。</span></p><p>【导师反馈】引导下属说出了担忧和疑虑，为你点赞！</p><p><span class="fontBlue">我</span><span>我理解你资源上的压力，还有对新项目前景的担心，让我们一一来解决。先谈什么呢？</span></p><p><span class="fontKS">柯胜</span><span>老实说我主要是担心这个项目的前景，担心公司，也担心自己的投入到时一场空。</span></p><p>【导师反馈】Get到了下属担心的点，接下来要如何回应呢？</p><p><span class="fontBlue">我</span><span>谢谢你的坦诚，公司在确定这个项目前做过一些调研分析，结果是积极的，才会决定启动这个项目。我可以请小A和你分享。（小A分享-语音）</span></p><p><span class="fontOrange">小A</span><span>我们之前已经做过调研，结果还是比较积极的。不过，任何创新过程都存在风险和不确定性，所以需要项目组配合做更深入的调研，我们需要根据调研结果来规划项目并管理风险。</span></p><p><span class="fontBlue">我</span><span>我们团队有责任及时反馈市场和用户信息，帮助公司做决策。就先聚焦在我们能做的部分吧。</span></p><p><span class="fontKS">柯胜</span><span>（无奈脸）也只能这样了。【一脸“有句话不知当不当讲”的样子】</span></p><p>【导师反馈】下属似乎还有顾虑，怎样才能让他心定？</p><p><span class="fontBlue">我</span><span>还是你对新项目有其他担心？没关系，说来听听。</span></p><p><span class="fontKS">柯胜</span><span>我在这块是“小白”，现在要做还真有点不知道该从哪里下手。（我是谁？我从哪里来？我要做什么？……）</span></p><p><span class="fontBlue">我</span><span>对你来说这的确是一个全新的领域，我能理解你的无力感。我们来看看可以做些什么让你快速上手。</span></p><p><span class="fontKS">柯胜</span><span>我可以自己找一些这方面的书或网上的资料，先看起来。</span></p><p>【导师反馈】在你的引导下，下属提出了解决方案，给你撒花花~</p><p><span class="fontBlue">我</span><span>我了解到魏宇对新产品领域是有一些研究的，可以邀请他来做个分享，这样你觉得可以帮助到你尽快熟悉起来吗</span></p><p><span class="fontKS">柯胜</span><span>那当然咯，有他的分享，我想一定能更快熟悉这块的。</span></p><p>【导师反馈】你不仅帮助下属化解了情绪，还提供了支持，给你加鸡腿！</p><p>你帮柯胜把变革中要做的事进行了梳理。（记事本形式呈现）</p><p class="imgBlock"><img style="width: 100%;" src="../../assets/picture/casepracticerevolution/bestRoadNote.png" /></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>在会议阶段柯胜的抗拒情绪就比较明显了。这个情况下，首先要运用变革加速器二，收集他的感受和想法并且表示同理；然后再运用变革加速器三及鼓励参与，帮助他梳理变革中不可掌控、可掌控、可影响的部分，让他重获掌控感。</p></div>'+
      // '<p class="changeTitle fontBlod">变革ing，跟进！跟进！再跟进</p><p>两个月之后，你组织项目组成员开了一次会议，会议的目的：</p><div class="bg-lightOrange"><p class="fontOrange">「最佳选择」</p><p class="smLineHeight">1.回顾项目进展。</p><p class="smLineHeight">2.对做得好的给予表扬，加强自信</p><p class="smLineHeight">3.对做得不好的，给予鼓励，维护自尊</p><p class="smLineHeight">4.提供必要的支持</p></div><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革过程中的监控和回顾对变革的成功起很大的作用，那么跟进会议就必不可少了，在会议上难道只是跟进项目嘛？并不然，及时奖励、提供支持才能让变革的走向成功。</p></div>'+
      // '<p>会议开始了，大家轮流进行汇报，首先是开发工程师魏宇汇报工作。</p><p><span class="fontWY">魏宇</span><span>经过这两个月的加班加点，调研的内容已经完成，同时，开发已经……（一切顺利，成果显著）。【具体内容，成果显著】</span></p><p class="fontOrange">「最佳选择」</p><p><span class="fontBlue">我</span><span>大家对你的调研报告评价很高，同时，你还提前完成部分开发工作，给后期的工作打下了良好的基础，非常给力哦！ </span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>魏宇对变革本身就是适应的状态，并且在变革中取得了不错的成绩，这个时候的鼓励就像一针强心针，能够有助变革顺利进行。</p></div>'+
      // '<p>接下来是项目经理林薇汇报工作。</p><p><span class="fontLW">林薇</span><span>老大，我已经把项目的整体排期方案做好了，但是涉及到数据分析方面的内容还没有开始做，因为市场部迟迟没有给到数据。【具体内容，成果一般，需要协助】</span></p><p><span class="fontBlue">我</span><span>你的排期方案做得非常细致，考虑很周全，不亏是公认的“大管家”。拿不到市场部数据会导致延期，你准备怎么跟进？</span></p><p><span class="fontLW">林薇</span><span>催了几次都不见效果，我打算约他们主管谈下，看看到底什么情况。</span></p><p>【导师反馈】维护自尊，鼓励参与，让下属动起来。</p><p><span class="fontBlue">我</span><span>嗯，了解清楚状况再看看怎么解决比较好，反复催可能不会有效果。谈完后如果有需要我帮忙的地方告诉我。</span></p><p><span class="fontLW">林薇</span><span>谢谢老大的建议和支持，我尽快了解清楚后再采取行动。</span></p><p>【导师反馈】鼓励建议加支持，效果翻倍。墙都不扶就服你！</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革本身就是不易的，林薇一开始对变革持观望态度，在进度一般的情况下，指责和不信任都会让她失去继续进行下去的信心，给予支持才能够让她有动力将变革进行到底。</p></div>' +
      // '<p>最后，是产品设计师柯胜汇报工作。</p><p><span class="fontKS">柯胜</span><span>老大，我这边的部分，因为难度确实比较大，我花了大半个月的时间才刚刚了解完市场情况，做完调研报告，具体的情况是……（进度不佳，成果一般）。【具体内容，进展缓慢】</span></p><p><span class="fontBlue">我</span><span>你调研报告中的目标客户群体分析，让我们看到原本的假设里面忽略的部分，而且你的验证非常确凿，对后面产品的设计有很大的参考价值。</span></p><p><span class="fontKS">柯胜</span><span>非常感谢老大的认可，接下来我会更加努力的！</span></p><p>【导师反馈】肯定下属的成果，维护自尊。给你99分，剩下1分怕你骄傲。</p><p><span class="fontBlue">我</span><span>关于进度的问题，你这边是有什么困难吗？</span></p><p><span class="fontKS">柯胜</span><span>产品设计过程中牵涉到的人比较多，前期讨论时，很难约大家的时间。另外，因为没能及时调整方案，并且通知项目组其他人，所以项目进展不太顺利。</span></p><p>【导师反馈】循循善诱让下属敞开心扉，继续努力哦！</p><p><span class="fontBlue">我</span><span>我又要顾着调整方案，又要协调那么多人员，你的确不容易啊！那接下来有什么计划赶上进度吗？</span></p><p><span class="fontKS">柯胜</span><span>目前我们已经调整了方案，现在的计划是……（叙述计划）</span></p><p>【导师反馈】下属胸有成竹，胜利在望的感觉不错吧？</p><p><span class="fontBlue">我</span><span>嗯，有任何问题，可以随时找我。你是我们的骨干产品设计师，相信你能很快赶上进度，保证我们如期交付。</span></p><p><span class="fontKS">柯胜</span><span>老大，我一定不负众望。</span></p><p>【导师反馈】下属信心满满，干劲十足。看好你哟！</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革的过程中，柯胜一直持抗拒的态度。在进度不佳的状况下，你不仅不应该大骂一顿，反而应该看到他值得肯定的地方维护自尊，运用提问的方式帮助他找出跟上进度的方案。</p></div><p>会议结束，项目持续进行中…</p>';

      // this.apiService.ajax({
      //   'type':'get',
      //   'url':'/api/exerciseTutor/'+this.exerciseId
      // }).subscribe(result=>{
      //   this.tutor = result.tutor;
      //   this.optimum = result.optimum;
      // });
    });
  }

  updateExerciseReports() {
    this.apiService
      .ajax({
        type: "get",
        url:
          "/sr/insideapi/updateExerciseReports?exerciseId=" + this.exerciseId,
      })
      .subscribe((result) => {
        this.getKasInfo();
      });
  }

  getKasInfo() {
    this.apiService
      .ajax({
        type: "get",
        // 'url':'/api/practices/'+this.exerciseId+'/'+this.practiceId+'/report'
        url:
          "/sr/maxSimulation/reports/" +
          this.exerciseId +
          "/" +
          this.practiceId,
      })
      .subscribe((result) => {
        //无报告数据转向列表页
        this.practiceMetaId = result.practiceMetaId;
        this.report = result.reports.kas;
        this.reportName = result.reports.name;
        this.finished = result.allExerciseFinished;
        this.getLevelInfo(result.reports);
      });
  }

  getLevelInfo(reports) {
    let that = this;
    $.ajax({
      url: "/sr/insideapi/getlevel",
      type: "post",
      dataType: "json",
      contentType: "application/json;charset=utf-8",
      data: JSON.stringify(this.getKaList(reports)),
      async: false,
      headers : {
        'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
        'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
      },
      success: function (result) {
        if (result && result != "") {
          that.reportKAData = result;
          that.targetShow = 1;
        } else {
          that.targetShow = 0;
        }
      },
      error: function (er) {
        that.targetShow = 0;
        if(er.status === 401 && Number(er.responseJSON.code) === 106){
          that.storeService.notification.notAuthed.next(true);
        }
      },
    });

    if (reports.name == "组织与计划") {
      this.mode = 2;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticepando/star2.png";
    } else if (reports.name == "影响力") {
      this.mode = 3;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report.png";
    } else if (reports.name == "驱动变革") {
      this.mode = 4;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report2.png";
    } else {
      this.mode = 1;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report.png";
    }

    if (that.targetShow === 0) {
      this.isShowReportLv = false;
    } else {
      this.isShowReportLv = true;
    }

    setTimeout(() => {
      this.itemClickEnable = true;
    }, 500);
  }

  ngAfterViewInit() {
    let that = this;
    this.commonService.initPage({
      backgroundColor: "white",
    });
    $(document).ready(function () {
      var listenerTimeout = setInterval(function () {
        var bestPathEle = document.getElementById("bestPathBox"),
          analysisEle = document.getElementById("analysisContent"),
          tutorEle = document.getElementById("tourReviewBox");
        if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
          bestPathEle.addEventListener("scroll", that.onBestPathScroll);
          analysisEle.addEventListener("scroll", that.onAnalysisScroll);
          tutorEle.addEventListener("scroll", that.onTutorScroll);
          clearInterval(listenerTimeout);
        }
      }, 500);
    });
  }

  /*
    格式化KA对象方法
     report：传递一个报告对象
   */
  getKaList(report) {
    let kaJson = {
      id: report.id,
      name: report.name,
      type: report.type,
      kas: {},
      exercisesId: this.exerciseId,
      questionId: null,
      optionId: null,
    };
    if (window["exercises" + this.exerciseId] != null) {
      let exerciseConfig = window["exercises" + this.exerciseId];
      kaJson.questionId = exerciseConfig.questionId;
      kaJson.optionId = exerciseConfig.optionId;
    }

    if (report) {
      for (let i = 0; i < report.kas.length; i++) {
        let kaItem = report.kas[i];
        if (kaItem) {
          //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
          kaJson.kas[kaItem.name] = kaItem.value;
        }
      }
    }
    return kaJson;
  }

  close() {
    this.apiService
      .ajax({
        type: "get",
        url: "/api/learningpathes/" + this.learningPathId,
      })
      .subscribe((result) => {
        //转向情景列表
        let link = this.abilityConfig.getPracticeLinkList(
          result.name,
          this.learningPathId,
          this.practiceMetaId
        );
        if (link.length > 0) {
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        }
      });
  }

  onBestPathScroll() {
    var overlay = document.getElementById("bestPathBox");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onAnalysisScroll() {
    var overlay = document.getElementById("analysisContent");
    console.log("scroll1");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onTutorScroll() {
    var overlay = document.getElementById("tourReviewBox");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  subWrapOneOut() {
    $("#subWrapOne").fadeOut(function () {
      $("#subWrapTwo").fadeIn();
      $("#btnWrap").fadeIn();
    });
  }

  tourReviewBoxIn() {
    $("#tourReviewShade").fadeIn();
    $("#tourReviewBox").fadeIn();
    $(".closeBtn" + this.skinColor).fadeIn();
    this.pathClickable = false;
  }

  tourReviewBoxOut() {
    $("#tourReviewShade").fadeOut();
    $("#tourReviewBox").fadeOut();
    $(".closeBtn" + this.skinColor).fadeOut();
    this.pathClickable = true;
  }

  bestPathIn() {
    if (!this.pathClickable) {
      return;
    }
    $(".closeBtn" + this.skinColor).fadeIn();
    this.bestPathBoxShow = true;
    $("#shade").fadeIn();
  }

  bestPathOut() {
    $(".closeBtn" + this.skinColor).fadeOut();
    this.bestPathBoxShow = false;
    $("#shade").fadeOut();
  }

  redo() {
    if (!this.pathClickable || this.redoClickedStatus) {
      return;
    } else {
      this.redoClickedStatus = true;
    }

    this.apiService
      .ajax({
        type: "get",
        url: "/sr/maxSimulation/reset/" + this.exerciseId,
      })
      .subscribe((result) => {
        let link = [
          "case-practice-performance",
          this.practiceId,
          this.exerciseId,
          this.learningPathId,
          this.practiceMetaId,
        ];
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate(link);
        }

      });
  }

  analysisBoxIn(i) {
    if (!this.itemClickEnable) {
      return false;
    }
    let _this = this;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].value;
    this.currentAnalysis = this.report[i].analysis;
    $("#analysisShade").fadeIn();
    // 滚动到订端
    $("#analysisContent").scrollTop(0);
    // $('#analysisBox').fadeIn();
    this.analysisBoxShow = true;
    $("body").css("overflow-y", "hidden");
    setTimeout(function () {
      _this.starShow = true;
    }, 300);

    this.pathClickable = false;

    document.getElementById("analysisShade").ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById("analysisHead").ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById("closeBtn3").ontouchmove = function (e) {
      e.preventDefault();
    };
  }

  analysisBoxOut() {
    $("#analysisShade").fadeOut();
    this.analysisBoxShow = false;
    $("body").css("overflow-y", "scroll");
    this.starShow = false;
    this.pathClickable = true;
  }

  goToList() {
    if (this.goToListClickedStatus) {
      return;
    } else {
      this.goToListClickedStatus = true;
    }
    this.apiService
      .ajax({
        type: "get",
        url: "/api/learningpathes/" + this.learningPathId,
      })
      .subscribe((result) => {
        //转向情景列表
        console.log("name:" + result.name);
        let link = this.abilityConfig.getPracticeLinkList(
          result.name,
          this.learningPathId,
          this.practiceMetaId
        );
        if (link.length > 0) {
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        }
      });
  }

  linkToPostSurvey() {
    this.apiService
      .ajax({
        type: "get",
        url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
      })
      .subscribe((result) => {
        this.learningPathMetaId = result.data;
        this.apiService
          .getOrCreateLearningPath(this.learningPathMetaId)
          .subscribe((result) => {
            this.learningPath = result;
            if (this.learningPath.subItems.length == 3) {
              this.apiService
                .ajax({
                  type: "get",
                  url: "/sr/learningtour",
                })
                .subscribe((result) => {
                  this.learningTour = result;
                  let link = ["survey", this.learningTour.tour_id, 3, 2];
                  this.router.navigate(link);
                });
            } else {
              let link = [
                "survey",
                this.learningPath.id,
                this.learningPath.subItems[4].surveyMetaId,
                1,
              ];
              this.router.navigate(link);
            }
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-performance-report/case-practice-performance-report.component.ts